export default __webpack_public_path__ + "static/plentymarkets_logo-91fe9f866326eb762de14dcf10237abe.svg";